import axios from "axios";

const baseURL = "/psql/";

export default {
  // search searches the database based on set of conditions
  search(url: string, conditions: any, options: any = {}) {
    // const role = "allochi";
    options = {
      params: conditions,
      headers: { Prefer: "count=exact", ...options.headers },
    };
    return axios.get(baseURL + url, options);
  },

  // load selects a single record from the database by id
  // @url the table/view postgrest url
  // @id  the id of the record to be loaded
  // @select  the set of columns to be loaded in postgrest format
  load(url: string, id: number, select: any) {
    let options = {
      params: { id: `eq.${id}`, select },
      headers: { Accept: "application/vnd.pgrst.object+json" },
    };
    return axios.get(baseURL + url, options);
  },

  // save inserts or updates an object to the database
  // if the object has an id it update the record on the database
  // otherwise it create new one with insert
  save(url: string, object: any, option: any) {
    // const role = "allochi";
    option = Object.assign({}, option, {
      headers: {
        Accept: "application/vnd.pgrst.object+json",
        Prefer: "return=representation",
      },
    });
    if (object.id != null) {
      const id = `eq.${object.id}`;
      option = Object.assign({}, option, {
        params: { id },
      });
      return axios.patch(baseURL + url, object, option);
    } else {
      return axios.post(baseURL + url, object, option);
    }
  },

  // inserts a list of objects to the database
  // bulkSave(url: string, objects: any, option: any) {
  //   option = Object.assign({}, option, {
  //     headers: {
  //       Prefer: "return=representation",
  //     },
  //   });

  //   const oldObjects = objects.filter(o => o.id !== undefined);
  //   const newObjects = objects.filter(o => o.id === undefined);

  //   const promises = [];
  //   promises.push(axios.post(baseURL + url, newObjects, option));

  //   oldObjects.forEach((object: any) => {
  //     if (object.delete) {
  //       promises.push(this.delete(url, object.id));
  //     } else {
  //       promises.push(
  //         this.save(url, object, option).then(r => ({
  //           data: [r.data],
  //         }))
  //       );
  //     }
  //   });

  //   return Promise.all(promises).then(responses => ({
  //     data: responses
  //       .map(r => r.data)
  //       .reduce((acc, data) => [...acc, ...data], []),
  //   }));
  // },

  // delete deletes an object from the database
  // this function depends on the database to authorize deletions
  // the table uses a trigger to check current user and references
  delete(url: string, id: number) {
    // const role = "allochi";
    if (id != null && id > 0) {
      return axios.delete(baseURL + url, { params: { id: `eq.${id}` } });
    }
  },

  // rpc calls a remote procedure
  rpc(url: string, params: any, options: any) {
    return axios.post(baseURL + "rpc/" + url, params, options || {});
  },
};
